// extracted by mini-css-extract-plugin
export default {"disponibiliteButton":"DisponibiliteButton_disponibiliteButton__Hji-o"};